// extracted by mini-css-extract-plugin
export default {"nav":"nav--vy8hq","navbar":"navbar--vy8hq","dark":"dark--vy8hq","left":"left--vy8hq","menu":"menu--vy8hq","isOpen":"isOpen--vy8hq","right":"right--vy8hq","logo":"logo--vy8hq"};